<template>
  <div v-if="selectedNews" class="flex flex-col">
    <NText variant="caption1" weight="bold">
      {{ selectedNews.messageTitle }}
    </NText>
    <div class="flex text-neutral-secondary-hover">
      <NText variant="overline" class="align-middle ms-1">
        {{ selectedNewsTime }}
      </NText>
    </div>
    <div
      class="max-h-[270px] h-full overflow-y-scroll bg-neutral-secondary rounded-md mt-3 p-2"
    >
      <NText variant="caption1" class="align-middle ms-1">
        {{ selectedNews.messageText }}
      </NText>

      <div class="flex flex-wrap">
        <template
          v-for="(tag, index) of selectedNews.tags"
          :key="`${tag.isin}${index}`"
        >
          <div
            v-if="tag.eighteenCharacterInstrumentNameOfAfcNorm"
            class="inline-flex mt-2 items-center ml-1"
          >
            <NCheap
              :label="tag.eighteenCharacterInstrumentNameOfAfcNorm"
              :closable="false"
              size="small"
              class="cursor-pointer"
              disabled
              @click.stop="updateActiveIsin(tag.isin)"
            />
          </div>
        </template>
      </div>
    </div>
  </div>

  <div v-else class="w-full flex items-center justify-center">
    <NLoading class="text-brand-primary" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { NText, NCheap } from '@negar/core';
import { NewsItem } from '@libs/api-reference';

import { useActiveSymbolIsin } from '@/modules/symbol';

type NewsDialogPropsType = {
  selectedNews: NewsItem;
};

const props = defineProps<NewsDialogPropsType>();

const { updateActiveIsin } = useActiveSymbolIsin();

const { d } = useI18n();

const selectedNewsTime = computed(() => {
  const newsDate = props.selectedNews?.date;

  if (newsDate) {
    return `${d(newsDate, 'shortTime')} ، ${d(newsDate, 'shortDate')}`;
  }

  return '';
});
</script>
